export const PROJECT_BASE_GQL_SCHEMA = `
  id
  version
  name
  invitationLink
  createdAt`

export const PROJECT_SETTINGS_GQL_SCHEMA = `
  iterationLength
  weekStartDay
  timeZone
  automaticPlanning
  initialVelocity`

export const PROJECT_MEMBER_GQL_SCHEMA = `
  id
  name
  avatarUrl`

export const MEMBER_GQL_SCHEMA = `
  id
  name
  username
  email
  avatarUrl
  role
  status`

export const LABEL_GQL_SCHEMA = `
  id
  name
  count`

export const STORY_BASE_GQL_SCHEMA = `
  id
  title
  description
  status
  storyType
  estimate
  requestedBy {
    ${PROJECT_MEMBER_GQL_SCHEMA}
  }  
  owners {
    ${PROJECT_MEMBER_GQL_SCHEMA}
  }
  labels {
    ${LABEL_GQL_SCHEMA}
  }
  deadline
  acceptedAt
  createdAt
  updatedAt
  deletedAt
  afterId
  beforeId
  iterationNumber
  blockedStoryIds
  subgroup`

export const BLOCKER_GQL_SCHEMA = `
  id
  storyId
  description
  resolved
  createdAt`

export const TASK_GQL_SCHEMA = `
  id
  storyId
  title
  finished
  afterId
  beforeId`

export const COMMENT_GQL_SCHEMA = `
  id
  storyId
  user {
    ${PROJECT_MEMBER_GQL_SCHEMA}
  }
  attachments {
    id
    commentId
    filename
    size
    contentType
    thumbnailable
  }
  content
  createdAt
  updatedAt`

export const INDEPENDENT_CHILDREN_GQL_SCHEMA = `
  comments {
    ${COMMENT_GQL_SCHEMA}
  }
  tasks {
    ${TASK_GQL_SCHEMA}
  }
  blockers {
    ${BLOCKER_GQL_SCHEMA}
  }`

export const ITERATION_GQL_SCHEMA = `
  number
  start
  finish
  teamStrength
  velocity
  effectivePoints
  acceptedPoints
  projectId`

export const PROJECT_GQL_SCHEMA = `
  ${PROJECT_BASE_GQL_SCHEMA}
  ${PROJECT_SETTINGS_GQL_SCHEMA}
  stories {
    ${STORY_BASE_GQL_SCHEMA}
    ${INDEPENDENT_CHILDREN_GQL_SCHEMA}
  }
  iterations {
    ${ITERATION_GQL_SCHEMA}
  }
  labels {
    ${LABEL_GQL_SCHEMA}
  }`

export const PROJECT_CURRENT_ITERATION_GQL_SCHEMA = `
  currentIteration @client {
    ${ITERATION_GQL_SCHEMA}
  }`

export const PROJECT_DEADLINES_GQL_SCHEMA = `
  iterationDeadlines @client {
    iterationNumber
    deadlines {
      title
      deadline
    }
  }`

export const NOTIFICATION_GQL_SCHEMA = `
  id
  projectId
  projectName
  performedById
  storyId
  storyTitle
  message
  context
  type
  entityId
  createdAt
  readAt`

export const LIVE_SIGNAL_GQL_SCHEMA = `
  projectId
  performedById
  storyIds
  version`

export const SEARCH_STORIES_GQL_SCHEMA = `
  stories {
    ${STORY_BASE_GQL_SCHEMA}
    ${INDEPENDENT_CHILDREN_GQL_SCHEMA}
  }
  totalHits
  totalHitsWithDone
  totalPoints
  totalPointsCompleted`

export const STORY_HISTORY_GQL_SCHEMA = `
  id
  projectId
  storyId
  entityType
  entityId
  description
  performedById
  createdAt`

export const COMMAND_META = {
  PARAMS: `
    $projectId: ID!
    $version: Long!
    $commandId: ID!
    $personId: ID!
    $type: CommandType!
    $parameters: JSON!`,
  INPUT: `
    projectId: $projectId
    version: $version
    commandId: $commandId
    personId: $personId
    type: $type
    parameters: $parameters`,
}

export const STORY_COMMAND_META = {
  ...COMMAND_META,
  OUTPUT: `
    version
    type
    __typename
    data {
      __typename
      ... on Story {
        ${STORY_BASE_GQL_SCHEMA}
      }
    }`,
}

export const STORY_CREATE_COMMAND_META = {
  ...COMMAND_META,
  OUTPUT: `
    version
    type
    __typename
    data {
      __typename
      ... on Story {
        ${STORY_BASE_GQL_SCHEMA}
        ${INDEPENDENT_CHILDREN_GQL_SCHEMA}
      }
    }`,
}

export const STORY_ORDER_COMMAND_META = {
  ...COMMAND_META,
  OUTPUT: `
    version
    type
    __typename
    data {
      __typename
      ... on Story {
        id
        afterId
        beforeId
        subgroup
      }
    }`,
}

export const BLOCKER_COMMAND_META = {
  ...COMMAND_META,
  OUTPUT: `
    version
    type
    __typename
    data {
      __typename
      ... on Blocker {
        ${BLOCKER_GQL_SCHEMA}
      }
      ... on Story {
        id
        updatedAt
        blockedStoryIds
      }
    }`,
}

export const COMMENT_COMMAND_META = {
  ...COMMAND_META,
  OUTPUT: `
    version
    type
    __typename
    data {
      __typename
      ... on Comment {
        ${COMMENT_GQL_SCHEMA}
      }
    }`,
}

export const TASK_COMMAND_META = {
  ...COMMAND_META,
  OUTPUT: `
    version
    type
    __typename
    data {
      __typename
      ... on Task {
        ${TASK_GQL_SCHEMA}
      }
    }`,
}

export const LABEL_COMMAND_META = {
  ...COMMAND_META,
  OUTPUT: `
    version
    type
    __typename
    data {
      __typename
      ... on Label {
        ${LABEL_GQL_SCHEMA}
      }
    }`,
}

export const ITERATION_COMMAND_META = {
  ...COMMAND_META,
  OUTPUT: `
    version
    type
    __typename
    data {
      __typename
      ... on Iteration {
        ${ITERATION_GQL_SCHEMA}
      }
    }`,
}
